import subscribeToTaskChanges from "../api/task/subscribeToTaskChanges";

import {
    getTaskStages,
    getTasks,
    editTask,

    approveTask,
    rejectTask,
    inspectTask,
    deleteFile,
    scheduleTask,
    completeTask,
} from "../workers/task.worker";

//import addTask from "../api/task/addTask";
//import deleteTask from "../api/task/deleteTask";

import Vue from "vue";

const TaskStore = {
    namespaced: true,
    state: {
        stream: null,

        isStagesLoading: false,
        stages: [],

        tasks: [],

        tasksByStage: {},
        tasksTotalByStage: {},
    },
    getters: {
        getAllTasks ({ tasks }) {
            return tasks;
        },
        getTasks ({ tasksByStage }) {
            return (stageId) => {
                if (stageId) {
                    return tasksByStage[stageId] ?? [];
                }
                return [];
            };
        },
        getTaskById ({ tasks }) {
            return (taskId) => {
                if (taskId) {
                    return tasks.find(
                        ({ _id }) => _id === taskId
                    );
                }
                return undefined;
            }
        },
        getTaskTotal ({ tasksTotalByStage }) {
            return (stageId) => {
                if (stageId) {
                    return tasksTotalByStage[stageId] ?? 0;
                }
                return 0;
            };
        },
    },
    mutations: {
        setLoading (state, { type, status }) {
            state[type] = status;
        },
        setStream (state, stream) {
            state.stream = stream;
        },
        setTaskStages (state, stages) {
            state.stages = stages;
        },
        setTasks (state, tasks) {
            state.tasks = tasks;
        },
        setTasksByStages (
            state,
            { stageId, result }
        ) {
            const { total, data } = result;
            state.tasks = state.tasks.concat(data);
            Vue.set(
                state.tasksByStage,
                stageId,
                data,
            );
            Vue.set(
                state.tasksTotalByStage,
                stageId,
                total,
            );
        },
        appendTasksByStages (
            state,
            { stageId, result }
        ) {
            const { total, data } = result;
            state.tasks = state.tasks.concat(data);
            Vue.set(
                state.tasksByStage,
                stageId,
                state.tasksByStage[stageId].concat(data),
            );
            Vue.set(
                state.tasksTotalByStage,
                stageId,
                total,
            );
        },
        editTask (
            state,
            updatedTask
        ) {
            const targetIndex = state.tasks
                .findIndex(
                    ({ _id }) => _id === updatedTask._id
                );
            if (targetIndex > -1) {
                state.tasks
                    .splice(
                        targetIndex,
                        1,
                        updatedTask
                    );
            } else {
                state.tasks.push(updatedTask);
            }
        },
        deleteFileFromTask (
            state,
            { taskId, fileId }
        ) {
            const target = state.tasks
                .find(
                    ({ _id }) => _id === taskId
                );
            if (target) {
                const targetIndex = target.stageResponse["inspect"]
                    .findIndex(
                        ({ filename }) => filename === fileId
                    );
                if (targetIndex > -1) {
                    target.stageResponse["inspect"].splice(targetIndex, 1);
                }
            }
        },
        clear (state,) {
            state.stream = null;
            state.stages = [];
            state.tasks = [];
            state.tasksByStage = {};
            state.tasksTotalByStage = {};
        },
    },
    actions: {
        async getTaskStages (
            { commit }
        ) {
            commit("setLoading", { type: "isStagesLoading", "status": true });
            let taskStages;
            try {
                taskStages = await getTaskStages();
            } catch (e) {
                console.error(e);
                return;
            }
            commit("setTaskStages", taskStages);
            commit("setLoading", { type: "isStagesLoading", "status": false });
            return taskStages;
        },
        async getTasksByStage (
            { commit },
            stageId,
        ) {
            let result;
            try {
                result = await getTasks(stageId, 0, 50);
            } catch (e) {
                console.error(e);
                return;
            }
            commit(
                "setTasksByStages",
                { stageId, result }
            );
            return result;
        },
        async getMoreTasksByStage (
            { commit, state },
            stageId,
        ) {
            let result;
            try {
                result = await getTasks(stageId, state.tasksByStage[stageId].length, 50);
            } catch (e) {
                console.error(e);
                return;
            }
            commit(
                "appendTasksByStages",
                { stageId, result }
            );
            return result;
        },
        async listenToTaskStream (
            { commit }
        ) {
            const stream = subscribeToTaskChanges();
            commit(
                "setStream",
                stream
            );
            stream.subscribe({
                next: ({ action, task }) => {
                    switch (action) {
                        case "UPSERT": {
                            commit(
                                "editTask",
                                task,
                            );
                            break;
                        }
                        case "DELETE": {
                            commit(
                                "editTask",
                                task,
                            );
                            break;
                        }
                        default: {

                        }
                    }
                }
            });
            return stream;
        },

        /*async addTask (
            { commit },
            newTask
        ) {
            let task;
            try {
                task = await addTask(
                    newTask
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "addTask",
                task
            );
            return task;
        },*/

        async edit (
            { commit },
            updatedTask
        ) {
            let task;
            try {
                task = await editTask(
                    updatedTask._id,
                    updatedTask
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editTask", task);
            return task;
        },

        // manage tasks
        async approve (
            { commit },
            taskId
        ) {
            let task;
            try {
                task = await approveTask(taskId);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editTask", task);
            return task;
        },
        async reject (
            { commit },
            taskId
        ) {
            let task;
            try {
                task = await rejectTask(taskId);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editTask", task);
            return task;
        },
        async inspect (
            { commit },
            { taskId, attachments }
        ) {
            let task;
            try {
                task = await inspectTask(taskId, attachments);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editTask", task);
            return task;
        },
        async deleteFile (
            { commit },
            { taskId, fileId }
        ) {
            try {
                await deleteFile(taskId, fileId);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("deleteFileFromTask", { taskId, fileId });
        },
        async schedule (
            { commit },
            { taskId, installation }
        ) {
            let task;
            try {
                task = await scheduleTask(taskId, installation);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editTask", task);
            return task;
        },
        async complete (
            { commit },
            taskId
        ) {
            let task;
            try {
                task = await completeTask(taskId);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editTask", task);
            return task;
        },
    },
};

export default TaskStore;
